import * as controlService from "../services/ControlService";
import { FormBaseController } from "../components/fx";

const formConfig: any = {
    pageTitle: "Control Form",
    sections: [
        {
            type: "form",
            layout: 4,
            controls: [
                { label: 'Module Code', model: 'moduleCode', type: 'text', validations: ["required"] },
                { label: 'Control Code', model: 'controlCode', type: 'text', validations: ["required"] },
                {
                    label: 'Parent Control Code', model: 'parentControlCode', type: 'combo', default: true, defaultValue: "-1",
                    valueField: 'code', displayField: 'text', lookupKey: 'ParentControls'
                },
                { label: 'Display', model: 'display', type: 'text', validations: ["required"] },
                { label: 'Route Ref', model: 'routeRef', type: 'text' },
                { label: 'Icon Ref', model: 'iconRef', type: 'text' }
            ],
            actions: [
                { name: "add" },
                { name: "update" },
                { name: "cancel" }
            ]
        }
    ]
}

const formBaseController = FormBaseController({
    formConfig,
    actions: {
        add: controlService.addControl,
        update: controlService.updateControl,
        getItemById: controlService.getControlById,
        getLookups: controlService.getLookups
    }
}
);

export const useControlFormStore = formBaseController.getStore();
